import type { MouseEvent } from 'react'
import { ArrowLeft } from 'lucide-react'
import { Icon } from '../icons/Icon'
import { InlineLink } from './InlineLink'
import './backLink.css'

/**
 * The detail pages' back link: a 30px `--chip` circle plus the label, as ONE
 * link, left-aligned. Carries no outer margin: the parent spaces it. Same markup `AccountDetail`, `TransactionDetail` and
 * `BillChrome` each drew for themselves; all three render this now.
 */
export function BackLink({
  to,
  children,
  onClick,
}: {
  to: string
  children: string
  /** For a discard guard: the caller may `preventDefault()` to stop the navigation. */
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
}) {
  return (
    <div className="back-link">
      <InlineLink to={to} className="back-link__link" onClick={onClick}>
        <span className="back-link__chip" aria-hidden="true">
          <Icon glyph={ArrowLeft} size={14} />
        </span>
        {children}
      </InlineLink>
    </div>
  )
}
